var _circle, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "currentColor",
    strokeDasharray: "2 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 4.5,
    width: 1,
    height: 6,
    fill: "white",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9138 11.0369L15.6973 14.0585L15.5613 14.294L10.304 11.1894L10.9138 11.0369Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSI5LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtZGFzaGFycmF5PSIyIDMiLz4KICA8cmVjdCB4PSI5LjUiIHk9IjQuNSIgd2lkdGg9IjEiIGhlaWdodD0iNiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CiAgPHBhdGggZD0iTTEwLjkxMzggMTEuMDM2OUwxNS42OTczIDE0LjA1ODVMMTUuNTYxMyAxNC4yOTRMMTAuMzA0IDExLjE4OTRMMTAuOTEzOCAxMS4wMzY5WiIgZmlsbD0iY3VycmVudENvbG9yIgogICAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgClock as ReactComponent };